<script>
import { authComputed } from '@auth/helpers'

export default {
  name: 'ForgotPassword',
  props: {
    forgotPasswordError: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: '',
      errors: { email: '' },
      prettyForgotPasswordErrors: {
        non_existing_user:
          'There is no user confirmed with this Email Address or a password reset email has already been sent',
      },
    }
  },
  computed: { ...authComputed },
  methods: {
    loginByEmail() {
      this.$emit('active-page', { page: 'email' })
    },
    forgotPassword() {
      if (!this.email) {
        this.errors.email = 'Email required.'
      } else if (!this.validEmail(this.email)) {
        this.errors.email = 'Valid email required.'
      }
      if (!Object.values(this.errors).some((x) => x !== '')) {
        this.$emit('post-forgot-password', { email: this.email })
      }
    },
    validEmail(email) {
      const rule = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return rule.test(email)
    },
    clearForgotPasswordErrors(fieldName) {
      if (fieldName) {
        this.errors[fieldName] = ''
      }
      this.$emit('clear-forgot-password-errors')
    },
  },
}
</script>

<template>
  <div>
    <h1 class="home-headline1">Let's start sharing kyndfulness</h1>
    <h2 class="home-headline2">Forgot Password</h2>
    <div v-if="!successForgotPassword" class="mt-8 flex -mx-2">
      <div class="w-1/2 flex-grow pl-2 pr-4 relative">
        <input
          v-model="email"
          type="email"
          name="email"
          placeholder="Email"
          class="input"
          :class="[
            forgotPasswordError === 'non_existing_user' || errors.email !== ''
              ? 'border-red'
              : '',
          ]"
          @input="clearForgotPasswordErrors('email')"
        />
        <svg
          v-if="
            forgotPasswordError === 'non_existing_user' || errors.email !== ''
          "
          class="absolute right-0 top-0 mr-7 mt-2.5"
          xmlns="http://www.w3.org/2000/svg"
          width="17.433"
          height="15.57"
          viewBox="0 0 17.433 15.57"
        >
          <path
            class="a"
            fill="red"
            d="M19.066,17.847,12.211,5.978h0a1.808,1.808,0,0,0-.342-.483,1.772,1.772,0,0,0-2.505,0,1.715,1.715,0,0,0-.307.414h0L2.2,17.781v0a1.727,1.727,0,0,0-.246.535,1.769,1.769,0,0,0,1.764,2.229l13.707,0h0a1.77,1.77,0,0,0,1.636-2.7Zm-7.64.057a1.2,1.2,0,0,1-1.661,0,1.072,1.072,0,0,1-.354-.8,1.087,1.087,0,0,1,.354-.807,1.182,1.182,0,0,1,1.661,0,1.086,1.086,0,0,1,.354.807A1.07,1.07,0,0,1,11.426,17.9Zm.283-6.941c-.059.278-.136.6-.226.977-.086.352-.187.792-.3,1.32s-.229,1.178-.354,1.953h-.475q-.185-1.175-.355-1.958t-.3-1.311c-.079-.323-.15-.639-.216-.951a3.652,3.652,0,0,1-.1-.7,1.076,1.076,0,0,1,.351-.808,1.237,1.237,0,0,1,1.693,0,1.067,1.067,0,0,1,.362.808A3.393,3.393,0,0,1,11.709,10.963Z"
            transform="translate(-1.898 -4.978)"
          />
        </svg>
        <span
          v-if="forgotPasswordError === 'non_existing_user'"
          class="right-0 absolute mt-1.5 mr-7 text-red text-xxs capitalize text-right block w-full"
          >{{ prettyForgotPasswordErrors[forgotPasswordError] }}</span
        >
        <span
          v-if="errors.email !== ''"
          class="right-0 absolute mt-1.5 mr-7 text-red text-xxs capitalize text-right block w-full"
          >{{ errors.email }}</span
        >
      </div>
    </div>
    <div v-if="!successForgotPassword" class="mt-6 flex -mx-2 leading-xl">
      <div class="w-1/2 flex-grow pl-2 pr-4 flex content-start -mx-2">
        <div class="pl-2 pr-4">
          <button class="primary-button" @click="forgotPassword">Send</button>
        </div>
        <div class="pl-3 pr-2">
          <router-link :to="{ name: 'login' }" class="button secondary-button"
            >Cancel</router-link
          >
        </div>
      </div>
    </div>
    <div v-if="successForgotPassword" class="success-message mx-auto mt-5">
      <div class="mt-5 text-basel text-black">
        You have succesfully sent a password recovery email!
      </div>
      <div class="mt-5 pl-2 pr-4 text-center">
        <router-link :to="{ name: 'login' }" class="primary-button inline-block"
          >Login</router-link
        >
      </div>
    </div>
  </div>
</template>
